export default __webpack_public_path__ + "static/media/turbo_r.5f7ab0f0.jpg";